<script lang="ts">
	//Formatters
	import { format } from 'svelte-i18n';
	//Helpers
	import { bulkUpdate } from './app_settings_helper';
	import { onSettingsResponse } from '../../../helpers/device_settings_helpers';
	//Stores
	import { devices } from 'src/stores/lists/devices';
	//Design system components
	import { Toggle } from '@Shelly/shelly-design-system';
	//Types
	import type { Device } from '../../../types/Device';
	import { requestEditSharedDevice } from '../../Lists/list-helpers';
	import { pin_unlocked_devices } from 'src/stores/device-runtime/pin-unlocked';
	import { showNewLayout } from 'src/stores/toDelete/new_layout';
	import PinUnlock from 'src/components/PinUnlock.svelte';
	import { unlockPin } from 'src/helpers/pin_lock_helpers';
	import { isGen2EM, isProThreeEM } from 'src/helpers/interface_helpers';
	import { capFirstChar } from 'src/helpers/utilities';

	export let device: Device;

	const id = device.id;
	let checked = $devices[id].pin_lock || false;
	let initCheckedState = checked;
	let showModal = false;
	let pinLocked;

	$: pinLocked =
		typeof $pin_unlocked_devices[device.id] === 'undefined' && $devices[device.id]?.pin_lock;

	const handleUnlock = async (e) => {
		showModal = false;
		pinLocked = unlockPin(device, pinLocked);
		await save(e);
	};

	const handleClose = () => {
		checked = initCheckedState;
	};

	const save = async (e) => {
		e.preventDefault();

		const newCheckedValue = !checked;
		if (pinLocked) {
			showModal = true;
		} else {
			pin_unlocked_devices.remove_device(device);
			const pin_lock = newCheckedValue;

			if (isProThreeEM(device.type) || isGen2EM(device.type)) {
				for (const value of Object.values($devices)) {
					if (value.id.startsWith(id.split('_')[0]) && value.id !== id) {
						if (device.shared) {
							requestEditSharedDevice({ ...value, pin_lock });
						} else {
							bulkUpdate(value.id, { pin_lock });
						}
					}
				}
			}

			let res;
			if (device.shared) {
				const editDevice = device;
				editDevice.pin_lock = pin_lock;
				res = await requestEditSharedDevice(editDevice);
			} else {
				res = await bulkUpdate(id, { pin_lock });
			}

			let toastTexts = {};
			if (res?.isok) {
				checked = newCheckedValue;
				initCheckedState = pin_lock;
				toastTexts = {
					success: pin_lock
						? $format('enable_pin_lock_scc_toast', {
								default: 'PIN lock was enabled.',
							})
						: $format('disable_pin_lock_scc_toast', {
								default: 'PIN lock was disabled.',
							}),
				};
			}
			onSettingsResponse(res, device, toastTexts);
		}
	};
</script>

<Toggle {checked} size="m" on:click={save} id="toggle-lrtyzdy">
	{$showNewLayout
		? capFirstChar($format('sub_settings_title_pin_lock', { default: 'pin lock' }))
		: `${$format('enable', {
				default: 'Enable',
			})} ${$format('sub_settings_title_pin_lock', {
				default: 'pin lock',
			})}`}
</Toggle>

{#if showModal}
	<PinUnlock
		bind:showModal
		on:unlock={handleUnlock}
		on:close={handleClose}
		on:cancel={() => (showModal = false)}
	/>
{/if}
